// Accept only bounded embedded PNGs prepared by our authenticated upload endpoint.
export function receiptHeader(settings = {}) {
  const raw = settings.receipt_header_image;
  const image = typeof raw === 'string' && raw.length <= 400000 && /^data:image\/png;base64,[A-Za-z0-9+/]+={0,2}$/.test(raw) ? raw : '';
  const mode = settings.receipt_header_mode === 'none' ? 'none' : settings.receipt_header_mode === 'image' && image ? 'image' : 'text';
  const width = Number(settings.receipt_header_width_mm ?? 35);
  const size = Number(settings.receipt_name_size ?? 40);
  return { mode, image, width: Number.isFinite(width) && width >= 25 && width <= 40 ? width : 35,
    size: Number.isInteger(size) && size >= 25 && size <= 40 ? size : 40 };
}
